export const MIN_WIDTH_CARD = 220;
export const MIN_HEIGHT_CARD = 164;
export const CARDS_GAP = 16;

export const GEONODEIDMAPPING: Record<number, number> = {
  // Bangkok
  219: 9645,
  10036: 9645,

  // Istanbul
  1081344: 9721,
  10040: 9721,

  // Los Angeles
  1030: 9744,
  1736: 9744,
  1379: 9744,
  288: 9744,
  1063: 9744,

  // Milan
  1284: 9765,
  192: 9765,
  1075: 9765,

  // Paris
  330: 9777,
  1391: 9777,
  290: 9777,
  2065: 9777,

  // Rome
  607: 9795,
  365: 9795,

  // Tokyo
  1339: 9832,
  783: 9832,

  // Warsaw
  2040: 9843,
  1085594: 9843,

  // New York City
  596: 9773,
  902: 9773,
  1062: 9773,

  // London
  1775: 9743,
  1070: 9743,
  1068: 9743,
  1121: 9743,
  1047: 9743,
  1072447: 9743,
};
